import styled from 'styled-components';
import {MAP_LAYER_Z_INDEX} from '@/map/constants';
import {palette} from '@/styles';
import MarkerIcon from './assets/location-marker.png';
import TooltipArrow from './assets/tooltip-arrow.svg';

interface IProps {
  hasTooltip?: boolean;
}

export const LocationMarker = ({hasTooltip}: IProps) => {
  return (
    <Root>
      {hasTooltip && (
        <Tootip>
          지도를 움직여서 정확한 위치를 확인해주세요.
          <img src={TooltipArrow} alt="툴팁" />
        </Tootip>
      )}
      <Icon src={MarkerIcon} alt="위치 마커" />
    </Root>
  );
};

const Root = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: ${MAP_LAYER_Z_INDEX.LOCATION};
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
`;

const Tootip = styled.div`
  position: absolute;
  padding: 4px 8px;
  border-radius: 8px;
  background-color: ${palette.gray900};
  color: ${palette.white};
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  width: 160px;
  text-align: center;
  bottom: 54px;
  left: -80px;
  img {
    position: absolute;
    bottom: -6px;
    left: calc(50% - 5px);
  }
`;

const Icon = styled.img`
  width: 44px;
  height: 44px;
  position: absolute;
  left: -22px;
  top: -44px;
`;
